import { Component } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'unsaved-changes-dialog',
  templateUrl: './unsaved-changes-dialog.component.html',
  styleUrls: [ './unsaved-changes-dialog.component.scss' ]
})
export class UnsavedChangesDialogComponent {

  public channel: Subject<boolean> = new Subject<boolean>();

  confirm() {
    this.channel.next(true);
  }

  cancel() {
    this.channel.next(false);
  }
}
